// extracted by mini-css-extract-plugin
module.exports = {"primary":"Button-module--primary--he22j","secondary":"Button-module--secondary--7vV9R","btn":"Button-module--btn--iV1ly","fullWidth":"Button-module--fullWidth--2m18k"};